/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { SportsEventUIModuleContentTreatment } from './sports-event-uimodule-content-treatment';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';
import { UiModuleSportsEventType } from './ui-module-sports-event-type';

/**
 * 
 * @export
 * @interface SportsEventUiModuleBody
 */
export interface SportsEventUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof SportsEventUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof SportsEventUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof SportsEventUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof SportsEventUiModuleBody
     */
    moduleType: SportsEventUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof SportsEventUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof SportsEventUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof SportsEventUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof SportsEventUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof SportsEventUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {SportsEventUIModuleContentTreatment}
     * @memberof SportsEventUiModuleBody
     */
    contentTreatment: SportsEventUIModuleContentTreatment;
    /**
     * 
     * @type {UiModuleSportsEventType}
     * @memberof SportsEventUiModuleBody
     */
    sportsEventType: UiModuleSportsEventType;
    /**
     * 
     * @type {string}
     * @memberof SportsEventUiModuleBody
     */
    contentListId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SportsEventUiModuleBody
     */
    contents?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SportsEventUiModuleBody
     */
    sportIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SportsEventUiModuleBody
     */
    leagueIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum SportsEventUiModuleBodyModuleTypeEnum {
    SPORTS_EVENT = 'SPORTS_EVENT'
}



